import { type SignUpStepId } from "../auth.schemas";

export const STEP_PARAM = "step";

/**
 * Present when the wizard was opened from an invitation email. It has to
 * survive every step change, so the flow reads it from the URL rather than
 * holding it in memory where a reload would lose it.
 */
export const INVITATION_PARAM = "invitationId";

export const STEP_BY_NUMBER: Record<number, SignUpStepId> = {
  1: "profile",
  2: "microphone",
  3: "preview",
  4: "trust",
  5: "verify-email",
};

export const STEP_NUMBER_BY_ID: Record<SignUpStepId, number> = {
  profile: 1,
  microphone: 2,
  preview: 3,
  trust: 4,
  "verify-email": 5,
};
